import { Help, HelpService } from '../../help';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import {HelpComponent} from '@app/_components/help/help/help.component';

@Component({
    selector: 'app-help-link',
    templateUrl: './help-link.component.html',
    styleUrls: ['./help-link.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class HelpLinkComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private dialog: MatDialog,
		private helpService: HelpService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.help = data.help;
	}

	@Input() help: Help;
	@Input() helpName: string;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Input() formReadOnly = false;
	// data
	helpId: number;

	// forms
	formLoading = false;
	formAlert: String;
	formTitle: String;

	ngOnInit() {
		this.primengConfig.ripple = true;

		// if we were passed the whole help object
		if (this.help) {
			this.helpId = this.help.helpId;
		}
		else{
			this.helpService.findByName(this.helpName).subscribe(
				res => {
					console.log('task-find SUCCESS: ' + JSON.stringify(res));
					this.help = res.data.help;
				});
		}
	}

	openHelpModal(help: Help) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			help: help,
			title: 'Edit Help',
			formReadOnly: this.formReadOnly
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(HelpComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);
				dialogRef.close();
			});
	}
}
